import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/* ═══════════════════════════════════════════════════════════════════════
   ALLER À L'ANCRE

   Un lien « /help#signaler » n'amenait nulle part. Deux raisons, qui se
   cumulaient :

     — le routeur change l'URL sans recharger la page, et le navigateur
       ne saute à l'ancre qu'au chargement d'un document ;
     — depuis que le contenu défile DANS le panneau et non dans la
       fenêtre, l'ancre native ne s'appliquerait de toute façon pas au
       bon conteneur.

   On attend une image avant de chercher l'élément : la cible n'existe
   pas encore au moment où l'URL change, la page vient de se monter.

   `scrollIntoView` remonte de lui-même jusqu'au bon parent défilant,
   quel qu'il soit — inutile de le désigner.
   ═══════════════════════════════════════════════════════════════════════ */

export default function AllerAlAncre() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      // Changer de page remet en haut : sans cela, on arrive au milieu
      // de la nouvelle, à la hauteur où l'on avait laissé la précédente.
      document.querySelector('main')?.scrollTo({ top: 0 });
      return undefined;
    }
    const cible = decodeURIComponent(hash.slice(1));
    let raf = requestAnimationFrame(() => {
      raf = requestAnimationFrame(() => {
        const el = document.getElementById(cible);
        if (!el) return;
        const sobre = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        el.scrollIntoView({ behavior: sobre ? 'auto' : 'smooth', block: 'start' });
        // Le focus suit le regard : sans lui, la navigation au clavier
        // repartirait du haut de la page après le saut.
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
        el.focus({ preventScroll: true });
      });
    });
    return () => cancelAnimationFrame(raf);
  }, [pathname, hash]);

  return null;
}
